<template>
  <div>
    <ShippingLabelNew
      :shipment="shipment"
      :purchaseOrder="purchaseOrder"
      v-if="shipment && shipment.labels && shipment.labels.find((e) => e.airBillNumber || e.packageNumber)"
      :key="(shipment.labels && JSON.stringify(shipment.labels)) || 1"
    />
    <div style="overflow-y: auto; max-height: 400px; min-height: 30px" class="card">
      <div class="card-body text-light" v-if="!rates || !rates.length">No rates loaded</div>
      <table v-else class="w-100 table table-striped table-fluid" :key="JSON.stringify(shipment.labels)">
        <thead>
          <tr>
            <th>Method</th>
            <th>Cost</th>
            <th>Price</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="rate in rates">
            <td class="">
              <div class="d-flex">
                <img :src="`/img/${rate.carrierCode}.png`" class="mr-2" style="max-height: 24px" />
                <!--
                <span class="badge badge-info p-2 small" v-if="rate.estimatedDays">{{ rate.estimatedDays }} days</span>
                -->
              </div>
              <div class="small">{{ rate.serviceName }}</div>
            </td>
            <td>
              {{ ((rate.shippingCost || rate.price) / 100) | currency(distributorCurrencySign) }}
              <i
                v-if="rate.usedCategoryShipping"
                class="far fa-exclamation-triangle ml-1"
                v-b-tooltip.hover
                :title="`This rate was use product category shippingPackages`"
              ></i>
            </td>
            <td>
              <strong>{{ (rate.price / 100) | currency(distributorCurrencySign) }}</strong>
            </td>
            <td>
              <div class="">
                <div class="d-flex align-center justify-content-start">
                  <button class="btn btn-primary btn-sm mr-2" @click="chooseRate(rate)">Select</button>
                  <ShippingLabelNew
                    @onSave="(e) => $emit('onSave', e)"
                    :rate="rate"
                    v-if="canAddLabel"
                    :purchaseOrder="purchaseOrder"
                    :fobPointId="fobPointId"
                    :productId="productId"
                    :shipment="shipment"
                    :supplierCode="supplierCode"
                  />
                  <div v-if="rate.error" class="ml-3">
                    <i class="fas fa-exclamation-circle text-danger" v-b-tooltip.hover :title="rate | rateErrorMessage"></i>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ShippingRatesDropdown',
  filters: {
    rateErrorMessage(rate) {
      return (rate.error?.response?.errors || [])
        .map(e => e.message)
        .join(',');
    }
  },
  components: { ShippingLabelNew: () => import('./Shipping/ShippingLabel/ShippingLabelNew') },
  props: {
    rates: {
      type: Array,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    purchaseOrder: {
      type: Object
    },
    productId: {
      type: String
    },
    supplierCode: {
      type: String
    },
    fobPointId: {
      type: String
    },
    shipment: {
      type: Object
    }
  },
  data() {
    return {};
  },
  computed: {
    canAddLabel() {
      return (
        !(this.shipment.labels && this.shipment.labels.find((e) => e.airBillNumber || e.packageNumber)) ||
        !(
          this.shipment.labels &&
          this.shipment.labels.length &&
          this.rates.map((e) => e.rateEstimateId).includes(this.shipment.labels[0].shipmentRateEstimateId)
        )
      );
    }
  },
  methods: {
    chooseRate(rate) {
      this.$emit('input', rate);
    }
  }
};
</script>
<style></style>
